<template>
  <div class="wrapper">
    <div class="md-layout-item md-size-33 mx-auto text-center">
      <md-button class="md-info" @click="downloadPDF" v-if="locations">
        TELECHARGER EN PDF
      </md-button>
    </div>

    <div style="text-align: center">
      <pulse-loader
        :loading="loading"
        :color="color"
        :size="size"
      ></pulse-loader>
    </div>

    <div
      style="margin-top: 70px; color: red; text-align: center; font-size: 1.2rem"
      v-if="!locations && !loading"
    >
      Aucun document correspondant. Veuillez cliquez sur le lien depuis votre
      adresse mail pour accéder au document.
    </div>

    <div
      id="pdf"
      style="margin-top: 50px; width: 100%; padding: 80px; color: black"
      v-if="locations"
    >
      <table style="width: 100%;">
        <tr>
          <td>
            <div class="logo" />
          </td>
          <td style="width: 90%; text-align: center">
            <div style="font-weight: 700; font-size: 1.6rem; color: #84e791;">
              GRELIANE DAGBEDJI
            </div>

            <div style="font-weight: 600; font-size: 1rem">
              Assistance et conseils en procédure de voyage – Achat et vente de
              <br />
              produits tropicaux (Cajou, soja, etc.) & Diverses prestations
            </div>

            <div style="font-weight: 600; color: red; font-size: 1rem">
              RCCM: RB/COT/18 A 40757 - IFU: 0201810436467
            </div>
            <div style="font-weight: 600; color: red; font-size: 1rem">
              RCCM: TG-LFW-01-2022-A-10-03809 - IFU: 1001806463
            </div>

            <div style="font-weight: 600; color: red; font-size: 1rem">
              Tél : (00229) 90 58 52 45 / (00228) 99 35 03 64
            </div>
          </td>
        </tr>
      </table>

      <div
        style="padding-left: 50px; padding-right: 50px; font-size: 1.3rem; line-height: 35px; margin-top: 130px; font-family: 'Cambria math',serif; color: black"
        v-if="trackFlow"
      >
        <div style="font-weight: 500">
          Cher Monsieur/Madame {{ locations.name }},
        </div>

        <div style="margin-top: 20px" v-if="trackFlow.isValid">
          Suite à votre ouverture de dossier au sein de notre structure, et
          après une analyse approfondie de votre curriculum vitae, nous pouvons
          vous notifier que la procédure voulue ({{ locations.procedure }} ,
          {{ locations.pays }}) peut être faisable que si vous mettez à notre
          disposition les pièces suivantes :
        </div>

        <div style="margin-top: 20px" v-if="!trackFlow.isValid">
          Suite à votre ouverture de dossier au sein de notre structure, et
          après une analyse approfondie de votre curriculum vitae, nous sommes
          désolés de vous notifier que la procédure voulue ({{
            locations.procedure
          }}
          , {{ locations.pays }}) ne pourra être faisable par notre structure vu
          que votre profil ne nous permettra pas de vous garantir le visa.
        </div>

        <div style="padding-top: 15px" v-if="trackFlow.isValid">
          <div
            style="margin-top: 5px"
            v-for="(item, index) in trackFlow.piece"
            :key="index"
          >
            ✅ {{ item }}
          </div>

          <div style="margin-top: 15px">
            <span style="font-weight: 600">NB :</span> Tous les documents
            doivent être scanné en agence pour le respect du format demandé par
            les collèges / universités contre 150 FCFA / page
          </div>

          <div style="margin-top: 15px">
            Une fois en possession de ces pièces mentionnées ci-dessus, vous
            pouvez vous rapprocher de nous pour la suite de la procédure.
          </div>
        </div>

        <div style="margin-top: 15px" v-if="trackFlow.isValid">
          Il faudra noter que votre profil est également bon pour:
          <span v-for="(item, index) in trackFlow.autre" :key="index">
            {{ item
            }}<span v-if="trackFlow.autre.length > index + 1">,</span> </span
          >.
        </div>

        <div style="margin-top: 15px" v-if="!trackFlow.isValid">
          Il faudra noter que votre profil est bon pour l'aboutissement des
          procédures suivantes:
          <span v-for="(item, index) in trackFlow.autre" :key="index">
            {{ item
            }}<span v-if="trackFlow.autre.length > index + 1">,</span> </span
          >.
        </div>

        <div style="margin-top: 15px">
          Nous vous souhaitons que du succès dans votre démarche.
        </div>

        <div style="margin-top: 15px">
          Veuillez agréer, cher(e) Madame/Monsieur, l’expression de nos
          salutations distinguées.
        </div>

        <div class="signature" />

        <div style="color: red; text-align: center; margin-top: 130px">
          <span>07BP590 – COTONOU </span>
          <span style="margin-left: 100px">grelianedagbedji@gmail.com</span>
        </div>
      </div>

      <br />
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/main";
import emailjs from "emailjs-com";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  bodyClass: "landing-page",
  components: {
    PulseLoader
  },

  props: {
    flow: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      error: false,
      locations: null,
      loading: true,
      color: "black",
      size: "30px"
    };
  },

  computed: {
    trackFlow() {
      return this.flow;
    }
  },

  created() {
    if (this.$route.query.id) {
      db.collection("souscriptions")
        .where("id", "==", this.$route.query.id)
        .get()
        .then(response => {
          response.forEach(doc => {
            // doc.data() is never undefined for query doc snapshots
            this.loading = false;
            this.locations = doc.data();
          });
        })
        .catch(error => {
          this.loading = false;
          console.log("Error getting documents: ", error);
        });
    }
  },

  methods: {
    downloadPDF() {
      html2canvas(document.querySelector("#pdf")).then(canvas => {
        // Element id is exportContent
        const imgData = canvas.toDataURL("image/jpeg");
        // console.log(imgData)

        const img = new Image();
        img.src = imgData;
        let event = this.locations.name;
        // According to the size of the picture set pdf specifications, to be executed when the image is loaded successfully, the reason why *0.5 is because of the proportional problem
        img.onload = function() {
          // Here you need to pay attention to, pdf horizontal and vertical two properties, you need to adjust according to the ratio of width and height, otherwise there will be incomplete display problems
          let doc = "";
          if (this.width > this.height) {
            doc = new jsPDF("p", "mm", [canvas.width, canvas.height]);
          } else {
            doc = new jsPDF("p", "mm", [canvas.width, canvas.height]);
          }
          doc.addImage(imgData, "jpeg", 10, 10, canvas.width, canvas.height); // The ratio can be adjusted as needed
          // Save as a different file name according to the download
          doc.save("GD-" + event + ".pdf");
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}
.logo {
  background-image: url("../../assets/img/logo.png");
  height: 120px;
  width: 120px;
  background-size: contain;
  background-repeat: no-repeat;
}

.signature {
  background-image: url("../../assets/img/signature.jpg");
  height: 180px;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
  margin-top: 70px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.md-success {
  margin-top: 3rem;
}
.hooper {
  height: auto;
}
.rad {
  margin-top: 30px;
}
.alert-success,
.alert-danger {
  margin-top: 50px;
}
</style>
